import React, { type FC } from 'react'
import { TableCell } from '@mui/material'
import { visuallyHidden } from '@mui/utils'

import { Translation } from '../../../../domain'

import { FormattedTranslation } from '../../Internationalization'
import { ColumnViewMenu } from './ColumnViewMenu'
import { RowActionsCell, trailingColumnStyle } from './RowActions'
import { useColumnView, useHasSelection, useOnColumnViewChange } from './State'
import type { Line } from './Types'

/**
 * Named "Actions" for assistive technology only when the rows have actions:
 * without them, the column view menu's button is the cell's only content, and it names itself
 */
export const TrailingHeaderCell: FC = () => {
    const hasSelection = useHasSelection()
    const view = useColumnView()
    const onColumnViewChange = useOnColumnViewChange()

    return (
        <TableCell data-testid="column-header-trailing" sx={trailingColumnStyle}>
            {hasSelection && (
                <span style={visuallyHidden}>
                    <FormattedTranslation id={Translation.ACTION} values={{ count: 2 }} />
                </span>
            )}
            {onColumnViewChange && <ColumnViewMenu view={view} onChange={onColumnViewChange} />}
        </TableCell>
    )
}

export const TrailingCell = <L extends Line>({ index, row }: Readonly<{ index: number, row: L }>): ReturnType<FC> => {
    const hasSelection = useHasSelection()

    return hasSelection ? <RowActionsCell index={index} row={row} /> : <TableCell sx={trailingColumnStyle} />
}
